import { useEffect, useState } from 'react'
import { Button, Header, Modal, Form, Checkbox } from 'semantic-ui-react'

import { Agency, MobileMoney, Till } from '../models'
import { ErrorMessage } from './error-message'
import { LoadingSpinner } from './loading-spinner'
import { AgencyService, TillService, MobileMoneyServiceService } from '../services'
import { FeedbackMessage } from '../constants'

export function TillCreateForm({ setCreateModalVisible, addTillToList, prefix = 'sup' }: { setCreateModalVisible: Function, addTillToList: Function, prefix?: string }) {

    const [name, setName] = useState('')
    const [agencyId, setAgencyId] = useState<number>()
    const [agencies, setAgencies] = useState<Agency[]>([])
    const [services, setServices] = useState<MobileMoney[]>([])
    const [selectedServiceIds, setSelectedServiceIds] = useState<number[]>([])

    const [loadingData, setLoadingData] = useState(true)
    const [creatingTill, setCreatingTill] = useState(false)
    const [error, setError] = useState(false)

    useEffect(() => {
        Promise.all([
            AgencyService.getAgenciesList(prefix),
            MobileMoneyServiceService.getMobileMoneyServices(prefix)
        ])
            .then(([a, s]) => { setAgencies(a); setServices(s) })
            .finally(() => setLoadingData(false))
    }, [prefix])

    const handleServiceToggle = (serviceId: number) => {
        
        setSelectedServiceIds(prev => prev.includes(serviceId) ? prev.filter(id => id !== serviceId) : [...prev, serviceId])
    }

    const handleFormSubmit = () => {

        if (!agencyId || !selectedServiceIds.length) return

        setCreatingTill(true)

        TillService.createTill({ name, agencyId, serviceIds: selectedServiceIds }, prefix)
            .then((till: Till) => {
                addTillToList(till)
                setCreateModalVisible(false)
            })
            .catch(() => setError(true))
            .finally(() => setCreatingTill(false))
    }

    const agencyOptions = agencies.map(a => ({ key: a.id, text: a.name, value: a.id }))

    return <Modal
        size='small'
        onClose={() => setCreateModalVisible(false)}
        onOpen={() => setCreateModalVisible(true)}
        open={true}>
        <Modal.Content>
            <Modal.Description>
                <Header as="h3">Nouvelle caisse</Header>
                {error && <ErrorMessage errorText={FeedbackMessage.SERVICE_CREATE_ERROR} />}
                <br />
                { loadingData ? <LoadingSpinner /> :
                    <Form>
                        {/* <Form.Input
                            fluid
                            label='Nom'
                            placeholder='Nom de la caisse'
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                        /> */}
                        <Form.Select
                            fluid
                            label='Agence'
                            options={agencyOptions}
                            placeholder='Choisir une agence'
                            onChange={(_, { value }) => setAgencyId(value as number)}
                        />
                        <Form.Field label='Services' />
                        {services.map(s => (
                            <div className='mb-8' key={s.id}>
                                <Checkbox
                                    toggle
                                    label={s.name + (s.bank ? ' ⟹ ' + s.bank : '')}
                                    onChange={() => handleServiceToggle(s.id!)}
                                />
                            </div>
                        ))}
                    </Form>
                }
                <br />
            </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
            <Button color='black' onClick={() => setCreateModalVisible(false)}>Annuler</Button>
            <Button color='orange' content="Confirmer" onClick={handleFormSubmit} loading={creatingTill} disabled={!agencyId} />
        </Modal.Actions>
    </Modal>
}
